function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import $ from 'jquery';
import { onLoad, WDHComponent } from '../../../../wdh-foundation/wdh';
import WDHTabbedGroup from './wdh-tabbed-group';

/**
 * gives sibling data-list-spots with the class .data-list-spot-tab Tabbed functionality
 * @memberOf module:wdh-tabbed-data-list
 *
 * TODO: Refactor code to allow for any selection of components to be placed in a tabbed list. Then add variants for data-list-spot
 */
var WDHTabbedDataList = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHTabbedDataList() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-list-spot-tab';
    _classCallCheck(this, WDHTabbedDataList);
    _this = _callSuper(this, WDHTabbedDataList, [className]);
    _this.options = {};
    /**
     * @private
     * @type {boolean}
     */
    _this.inEditMode = document.body ? document.body.classList.contains('mode-editing') : false;
    _this.titleClassName = 'data-list-spot-tab-title';
    _this.tabEndClass = 'tab-end';
    return _this;
  }

  // override the run function since this component is grouping several components into a single wrapper and should only be run once per group.
  _inherits(WDHTabbedDataList, _WDHComponent);
  return _createClass(WDHTabbedDataList, [{
    key: "run",
    value: function run() {
      var _this2 = this;
      onLoad(function () {
        var group = [];
        var tabGroup = null;

        // set groupOptions to our defaults
        var groupOptions = Object.assign({}, _this2.options);

        // loop through all components on the screen to determine if they are a tabbed data list spot.
        $('.component').each(function (index, element) {
          var $this = $(element);
          if ($this.hasClass(_this2.className) || $this.hasClass(_this2.titleClassName)) {
            // if a title is found between grouped elements, ignore it for now so we don't break the grouping.

            if ($this.hasClass(_this2.className)) {
              if (!tabGroup) {
                tabGroup = $this;
              } else {
                tabGroup = $.merge(tabGroup, $this);
              }
            }
            if ($this.hasClass(_this2.titleClassName)) {
              tabGroup.data('tabTitle', $this.text());
              tabGroup.data('tabName', $this.text().trim().replaceAll(' ', '-').toLowerCase());
            }
            if ($this.hasClass(_this2.tabEndClass)) {
              group.push(tabGroup);
              tabGroup = null;
            }
          } else {
            if (group.length) {
              _this2.setupGroup(group, groupOptions);
              // reset our group options so that additional tabbed list spots can work independently.
              groupOptions = Object.assign({}, _this2.options);
            }
            group = [];
          }
        });
        if (group.length) {
          _this2.setupGroup(group, groupOptions);
          // reset our group options so that additional tabbed list spots can work independently.
          groupOptions = Object.assign({}, _this2.options);
        }
      });
    }

    /**
     * initializes all components on the page that were grouped together as a single Tabbed Data List spot object.
     * @param {jQuery} group - group of DOM elements that have the default .data-list-spot-tab className.
     * @param groupOptions - custom options for the tabbed data list object
     */
  }, {
    key: "setupGroup",
    value: function setupGroup(group, groupOptions) {
      if (this.inEditMode) {
        group.forEach(function (elem, index) {
          elem.each(function (index, element) {
            $(element).addClass('tab-index');
            $(element).attr('data-index', "tab : ".concat(index + 1));
          });
        });
      }
      // Build each tabbed group component.
      var stack = new WDHTabbedGroup(group);
      groupOptions = Object.assign({
        editMode: this.inEditMode
      }, groupOptions);
      stack.setOptions(groupOptions);
      stack.init();
    }
  }]);
}(WDHComponent);
export default WDHTabbedDataList;